import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  card: {
    padding: 15,
    display: 'flex',
  },
  context: {
    margin: [0, 30],
  },
  header: {
    fontFamily: 'Gotham Pro',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: 16,
  },
  text: {
    fontFamily: 'SF UI Text',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 14,
    margin: [8, 0, 20, 0]
  },
  icon: {
    display: 'block',
  },
  '@media (max-width: 600px)': {
    icon: {
      display: 'none',
    }
  }
});

export default useStyles;
